import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Scale, FileText, Globe, Cookie, Link2, Briefcase, AlertTriangle, Shield, Lock, Users } from 'lucide-react';

const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_a85f478b-763e-4b7e-9f54-0dbb5a37a168/artifacts/fk4lgbat_Logo%20Phocea%20Rent.png";

const MentionsLegalesPage = () => {
  const sections = [
    {
      icon: FileText,
      title: "Conditions d'utilisation",
      content: `Phocea Rent® met en œuvre tous les moyens dont elle dispose pour assurer une information fiable et une mise à jour fiable de son site internet. Toutefois, des erreurs ou omissions peuvent survenir. L'internaute devra donc s'assurer de l'exactitude des informations auprès de Phocea Rent®, et signaler toutes modifications du site qu'il jugerait utile. Phocea Rent® n'est en aucun cas responsable de l'utilisation faite de ces informations, ni de tout préjudice direct ou indirect pouvant en découler.`
    },
    {
      icon: Cookie,
      title: "Cookies",
      content: `Le site www.phocearent.fr peut être amené à vous demander l'acceptation des cookies pour des besoins de statistiques et d'affichage. Un cookie est une information déposée sur votre disque dur par le serveur du site que vous visitez. Il contient plusieurs données qui sont stockées sur votre ordinateur dans un simple fichier texte auquel un serveur accède pour lire et enregistrer des informations. Certaines parties de ce site ne peuvent être fonctionnelles sans l'acceptation de cookies.`
    },
    {
      icon: Link2,
      title: "Liens hypertextes",
      content: `Le site internet peut offrir des liens vers d'autres sites internet ou d'autres ressources disponibles sur Internet. Phocea Rent® ne dispose d'aucun moyen pour contrôler les sites en connexion avec son site internet. Phocea Rent® ne répond pas de la disponibilité de tels sites et sources externes, ni ne la garantit. Elle ne peut être tenue pour responsable de tout dommage, de quelque nature que ce soit, résultant du contenu de ces sites ou sources externes, et notamment des informations, produits ou services qu'ils proposent, ou de tout usage qui peut être fait de ces éléments. Les risques liés à cette utilisation incombent pleinement à l'internaute, qui doit se conformer à leurs propres conditions d'utilisation.

Les utilisateurs, abonnés et visiteurs du site internet ne peuvent pas mettre en place un hyperlien en direction de ce site sans l'autorisation expresse et préalable de Phocea Rent®.

Dans l'hypothèse où un utilisateur ou visiteur souhaiterait mettre en place un hyperlien en direction du site internet de Phocea Rent®, il lui appartiendra d'adresser un email accessible sur le site afin de formuler sa demande de mise en place d'un hyperlien. Phocea Rent® se réserve le droit d'accepter ou de refuser un hyperlien sans avoir à en justifier sa décision.`
    },
    {
      icon: Briefcase,
      title: "Services fournis",
      content: `L'ensemble des activités de la société ainsi que ses informations sont présentés sur le site www.phocearent.fr.

Phocea Rent® s'efforce de fournir sur le site www.phocearent.fr des informations aussi précises que possible. Les renseignements figurant sur le site www.phocearent.fr ne sont pas exhaustifs et les photos sont non contractuelles. Ils sont donnés sous réserve de modifications ayant été apportées depuis leur mise en ligne. Par ailleurs, toutes les informations indiquées sur le site www.phocearent.fr sont données à titre indicatif et sont susceptibles de changer ou d'évoluer sans préavis.`
    },
    {
      icon: AlertTriangle,
      title: "Limitations contractuelles sur les données",
      content: `Les informations contenues sur ce site sont aussi précises que possible et le site est remis à jour à différentes périodes de l'année, mais peut toutefois contenir des inexactitudes ou des omissions. Si vous constatez une lacune, erreur ou ce qui paraît être un dysfonctionnement, merci de bien vouloir le signaler par email à l'adresse contact@phocearent.fr, en décrivant le problème de la manière la plus précise possible (page posant problème, type d'ordinateur et de navigateur utilisé, etc.).

Tout contenu téléchargé se fait aux risques et périls de l'utilisateur et sous sa seule responsabilité. En conséquence, Phocea Rent® ne saurait être tenue responsable d'un quelconque dommage subi par l'ordinateur de l'utilisateur ou d'une quelconque perte de données consécutive au téléchargement.

De plus, l'utilisateur du site s'engage à accéder au site en utilisant un matériel récent, ne contenant pas de virus, et avec un navigateur de dernière génération mis à jour.

Les liens hypertextes mis en place dans le cadre du présent site internet en direction d'autres ressources présentes sur le réseau Internet ne sauraient engager la responsabilité de Phocea Rent®.`
    },
    {
      icon: Shield,
      title: "Propriété intellectuelle",
      content: `Tout le contenu du présent site www.phocearent.fr, incluant, de façon non limitative, les graphismes, images, textes, vidéos, animations, sons, logos, gifs, icônes ainsi que leur mise en forme sont la propriété exclusive de Phocea Rent®, à l'exception des marques, logos ou contenus appartenant à d'autres sociétés partenaires ou auteurs.

Toute reproduction, distribution, modification, adaptation, retransmission ou publication, même partielle, de ces différents éléments est strictement interdite sans l'accord exprès par écrit de Phocea Rent®. Cette représentation ou reproduction, par quelque procédé que ce soit, constitue une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle. Le non-respect de cette interdiction constitue une contrefaçon pouvant engager la responsabilité civile et pénale du contrefacteur. En outre, les propriétaires des contenus copiés pourraient intenter une action en justice à votre encontre.`
    },
    {
      icon: Scale,
      title: "Litiges",
      content: `Les présentes conditions du site www.phocearent.fr sont régies par le droit français et toutes contestations ou litiges qui pourraient naître de l'interprétation ou de l'exécution de celles-ci seront de la compétence exclusive des tribunaux dont dépend le siège social de la société, sauf disposition légale impérative contraire.

La langue de référence, pour le règlement de contentieux éventuels, est le français.`
    },
    {
      icon: Lock,
      title: "Données personnelles",
      content: `De manière générale, vous n'êtes pas tenu de nous communiquer vos données personnelles lorsque vous visitez notre site Internet www.phocearent.fr.

Cependant, ce principe comporte certaines exceptions. En effet, pour certains services proposés par notre site, vous pouvez être amené à nous communiquer certaines données telles que : votre nom, votre fonction, le nom de votre société, votre adresse électronique et votre numéro de téléphone. Tel est notamment le cas lorsque vous remplissez le formulaire qui vous est proposé en ligne, dans la rubrique « contact ».

Dans tous les cas, vous pouvez refuser de fournir vos données personnelles. Dans cette hypothèse, vous ne pourrez pas utiliser certains services du site, notamment celui de solliciter des renseignements sur notre société ou de recevoir des informations.

Enfin, nous pouvons collecter de manière automatique certaines informations vous concernant lors d'une simple navigation sur notre site Internet, notamment : des informations concernant l'utilisation de notre site, comme les zones que vous visitez et les services auxquels vous accédez, votre adresse IP, le type de votre navigateur et vos temps d'accès.

De telles informations sont utilisées exclusivement à des fins de statistiques internes, de manière à améliorer la qualité des services qui vous sont proposés.

Les bases de données sont protégées par les dispositions de la loi du 1er juillet 1998 transposant la directive 96/9 du 11 mars 1996 relative à la protection juridique des bases de données.`
    },
    {
      icon: Users,
      title: "Informations sur le règlement en ligne des litiges",
      content: `Conformément à l'article 14, paragraphe 1, du Règlement relatif au règlement en ligne des litiges (RLL), la Commission européenne permet aux consommateurs de résoudre certains litiges en ligne via une plateforme dédiée.

Cette plateforme a pour objet de faciliter le règlement extrajudiciaire des litiges concernant des achats en ligne de biens ou de services.`
    }
  ];

  return (
    <div className="min-h-screen bg-black">
      {/* Header */}
      <header className="bg-black/95 backdrop-blur-sm border-b border-slate-800 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <img src={LOGO_WHITE} alt="Phocea Rent" className="h-10 w-auto" />
            </Link>
            <Link 
              to="/" 
              className="flex items-center gap-2 text-slate-400 hover:text-[#DFFF00] transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Retour au site
            </Link>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="py-16 bg-gradient-to-b from-slate-900/50 to-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-[#DFFF00]/10 border border-[#DFFF00]/30 rounded-full px-4 py-2 mb-6">
            <Scale className="w-4 h-4 text-[#DFFF00]" />
            <span className="text-[#DFFF00] text-sm font-medium">Informations légales</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Mentions légales
          </h1>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Conditions d'utilisation – Phocea Rent®
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Sections */}
          <div className="space-y-8">
            {sections.map((section, index) => (
              <article 
                key={index}
                data-testid={`mentions-section-${index + 1}`}
                className="bg-slate-900/30 border border-slate-800 rounded-2xl overflow-hidden"
              >
                <div className="bg-slate-800/50 px-6 py-4 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-[#DFFF00]/10 flex items-center justify-center">
                    <section.icon className="w-5 h-5 text-[#DFFF00]" />
                  </div>
                  <h2 className="text-lg font-semibold text-white">{section.title}</h2>
                </div>
                <div className="px-6 py-5">
                  <div 
                    className="text-slate-400 leading-relaxed whitespace-pre-line prose prose-invert prose-sm max-w-none
                      [&_strong]:text-white [&_strong]:font-semibold"
                    dangerouslySetInnerHTML={{ 
                      __html: section.content
                        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                        .replace(/\n/g, '<br/>')
                    }}
                  />
                </div>
              </article>
            ))}
          </div>

          {/* Liens */}
          <div className="flex flex-wrap gap-4 pt-12">
            <Link 
              to="/cgv" 
              data-testid="mentions-cgv-link"
              className="inline-flex items-center gap-2 bg-slate-800 text-white px-4 py-2 rounded-lg font-medium hover:bg-slate-700 transition-colors"
            >
              Conditions générales de location
            </Link>
            <Link 
              to="/confidentialite" 
              data-testid="mentions-confidentialite-link"
              className="inline-flex items-center gap-2 bg-slate-800 text-white px-4 py-2 rounded-lg font-medium hover:bg-slate-700 transition-colors"
            >
              Politique de Confidentialité
            </Link>
            <Link 
              to="/" 
              data-testid="mentions-home-link"
              className="inline-flex items-center gap-2 bg-[#DFFF00] text-black px-4 py-2 rounded-lg font-medium hover:bg-[#c8e600] transition-colors"
            >
              Retour à l'accueil
            </Link>
          </div>
        </div>
      </section>

      {/* Footer Mini */}
      <footer className="py-8 border-t border-slate-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-center text-sm text-slate-500">
            © {new Date().getFullYear()} Phocea Rent. Tous droits réservés.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default MentionsLegalesPage;
